import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditingSection } from '@app/features/questionnaire/components/questions/style-tab/section-editors/editing-section';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { buildRuntimePreviewContext } from '@app/features/questionnaire/components/questions/style-tab/preview/runtime-context.builder';
import { getExitPreviewData } from '@app/features/questionnaire/components/questions/style-tab/preview/preview-style.resolver';
import { QuestionType } from '@app/core/enums/questionnaire.enums';
import { ASSETS } from '@app/core/constants/assets.constants';

export type SurveyExitScreenMode = 'success' | 'duplicate';

@Component({
  selector: 'app-survey-exit-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-exit-screen.html',
  styleUrl: './survey-exit-screen.scss',
})
export class SurveyExitScreen implements OnInit {
  @Input() questionnaire: Questionnaire | null = null;
  @Input() mode: SurveyExitScreenMode = 'success';
  /** When MANUAL: show Google redirection block only if submitted score matched RATING condition (set by parent). */
  @Input() showReviewRedirection = false;
  @Output() createQuestionnaireClick = new EventEmitter<void>();

  ASSETS = ASSETS;
  msgToDisplay: string = '';
  redirectionOption: boolean = false;
  url: string = '';
  reviewProvider: boolean = false;

  get data() {
    if (!this.questionnaire) return null;
    const context = buildRuntimePreviewContext(
      this.questionnaire,
      EditingSection.EXIT_SCREEN
    );
    console.log('context', this.questionnaire);
    return getExitPreviewData(context);
  }

  ngOnInit(): void {

    if (this.questionnaire) {
      console.log('questionnaire', this.questionnaire); 
      const question = this.questionnaire.questions.find((q) => q.questionType === QuestionType.SOCIAL_REVIEW);
      if (question) {
        console.log('question', question);
        this.reviewProvider = question.questionSpecificOptions.reviewProvider === 'GOOGLE' ? true : false;
        this.url = question.questionSpecificOptions.reviewUrl || '';
        this.redirectionOption = question.questionSpecificOptions.redirectionOption === 'MANUAL' ? true : false;
        if (this.redirectionOption) {
          const questionConditions = question.questionConditions.find((qc) => qc.parameter === 'RATING');
          if (questionConditions) {
            this.msgToDisplay = questionConditions.decisionTree.msgToDisplay || '';
          }
        }
      }
    }
  }

  onBackToHome(): void {
    this.createQuestionnaireClick.emit();
  }
}
